import { useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    useNavigate
} from "react-router-dom";
import { useSelector } from 'react-redux';
import MTable from '../../Components/MTable/MTable';
import { completePO, deletePOHeader, getPO, journey, pendingDMPO, submitPOMHC, submitSL, updatePOHeader } from '../../Service/PurchaseOrderService';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay';
import moment from 'moment';
import 'moment/locale/id';
import { includes, set } from 'lodash';
import ModalForm from '../SalesOrder/ModalForm';

const PurchaseOrder = () => {
    let { userInfo } = useSelector(state => state.auth);
    moment.locale('id');
    const navigate = useNavigate();
    const tablePO = useRef();
    const [state, setState] = useState({ processing: false });
    const [modalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [journeyData, setJourneyData] = useState([]);
    const onAddData = () => {
        navigate("/purchaseorder/create");
    }

    const cancelPO = item => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modena',
                cancelButton: 'btn btn-readonly mr-3'
            },
            buttonsStyling: false
        })
        swalWithBootstrapButtons.fire(
            {
                title: 'Confirmation',
                text: 'Are you sure cancel this order ?',
                confirmButtonColor: '#3085d6',
                showCancelButton: true,
                confirmButtonText: 'Sure',
                reverseButtons: true
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {
                updatePOHeader(item.docnumpo, {
                    status: "CANCELED"
                }).then(res => {
                    if (res.status == 200) {
                        Swal.fire({
                            icon: 'success',
                            title: `Cancel Purchase Order success!`,
                        }).then(() => {
                            tablePO.current.refresh();
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: `Cancel Purchase Order error!`,
                            text: "Please try again or contact support!"
                        });
                    }
                }).catch(err => {
                    Swal.fire({
                        icon: 'error',
                        title: `Cancel Purchase Order error!`,
                        text: "Please try again or contact support!"
                    });
                })
            }
        })

    }

    const onEdit = item => () => {
        navigate("/purchaseorder/edit/" + item.docnumpo);
    };

    const onJourney = (docnumpo) => {
        setModalVisible(true);
        setIsLoading(true);
        journey(docnumpo).then(res => {
            if (res.data.length == 0) {
                Swal.fire({
                    icon: 'info',
                    title: 'Journey not found',
                    text: 'No journey found for this purchase order'
                });
                setIsLoading(false);
                return;
            } else {
                setJourneyData(res.data);
                setIsLoading(false);
            }
        }).catch(err => {
            console.error('Error fetching journey data:', err);
            setIsLoading(false);
        });

    };

    const onCancel = () => {
        setModalVisible(false);
        setJourneyData([]);
    };

    const onProcessCompleted = (docnumpo) => {
        setState({ ...state, processing: true })
        completePO(docnumpo).then(res => {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: `Process Complete success!`
            }).then(res => {
                tablePO.current.refresh();

            });
        }).catch(({ response }) => {
            const { message } = response?.data;
            Swal.fire({
                icon: 'error',
                title: `Process Complete error!`,
                text: message
            });
        }).finally(() => {
            setState({ ...state, processing: false })
        })
    };

    const onProcessPendingDM = (id_po) => {
        setState({ ...state, processing: true })
        pendingDMPO(id_po).then(res => {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: `Process success!`
            }).then(res => {
                tablePO.current.refresh();

            });
        }).catch(({ response }) => {
            const { message } = response?.data;
            Swal.fire({
                icon: 'error',
                title: `Process error!`,
                text: message
            });
        }).finally(() => {
            setState({ ...state, processing: false })
        })
    };

    const onProcessPOMHC = (id_po) => {
        setState({ ...state, processing: true })
        submitPOMHC(id_po).then(res => {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: `Process success!`
            }).then(res => {
                tablePO.current.refresh();

            });
        }).catch(({ response }) => {
            const { message } = response?.data;
            Swal.fire({
                icon: 'error',
                title: `Process error!`,
                text: message
            });
        }).finally(() => {
            setState({ ...state, processing: false })
        })
    };

    const onRemove = item => () => {
        Swal.fire(
            {
                icon: 'question',
                title: 'Are you sure?',
                text: 'Deleted Purchase can not be restored!',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {
                setState({ ...state, processing: true })
                deletePOHeader(item.docnumpo).then(res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: `Delete Purchase Order success!`
                    }).then(res => {
                        tablePO.current.refresh();

                    });
                }).catch(({ response }) => {
                    const { message } = response?.data;
                    Swal.fire({
                        icon: 'error',
                        title: `Delete Purchase Order error!`,
                        text: message
                    });
                }).finally(() => {
                    setState({ ...state, processing: false })
                })
            }
        })
    };

    const verificator_columns = [
        { id: 1, title: 'PO Number', field: 'docnumpo', sortable: true },
        { id: 3, title: 'Supplier', field: 'cardname', sortable: true },
        {
            id: 4,
            title: 'Order Type',
            field: 'm_tp_penj',
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.m_tp_penj == 'TRD') {
                    text = "TRADE-IN";
                } else if (data.m_tp_penj == 'FGS') {
                    text = "FINISH GOOD";
                } else if (data.m_tp_penj == 'PMR') {
                    text = "PAMERAN";
                }
                return text;
            },
        },
        {
            id: 5, title: 'Created Date', field: 'created_date', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD HH.MM.SS', example: 2023-03-01 06.30.23. You can also exclude the hour, minute, seconds, date, month or year. Example : 2023-03 and 2023-04-01 16.04",
            render: data => {
                // moment.locale('id');
                return moment(data.created_date).locale('id').format('ll LTS')
            }
        },
        /*{
            id: 99,
            title: 'Order Status',
            field: 'status',
            filter_text: "Please type 'Waiting Verification', 'Canceled' (exact wording)",
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.status === "Waiting Verification") {
                    text = <span className="badge bg-paid me-2" style={{width: "150px"}}>Waiting Verification</span>;
                } else if (data.status == "CANCELED") {
                    text = <span className="badge bg-red me-2">Cancelled</span>;
                }
                return text;
            },
        },
        {
            id: 6,
            title: 'Verification Status',
            field: 'verification_status',
            filter_text: "Please type 'Submitted', 'Rejected', 'Not Verified' (exact wording)",
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.verification_status === true) {
                    text = <span className="badge bg-paid me-2">Submitted</span>;
                } else if (data.verification_status === false) {
                    text = <span className="badge bg-red me-2">Rejected</span>;
                } else if (data.verification_status === null) {
                    text = <span className="badge bg-teal me-2">Not Verified</span>;
                } else if (data.status === "CANCELED") {
                    text = <span className="badge bg-red me-2">Cancelled</span>;
                }
                return text;
            },
        },*/
        {
            id: 99,
            title: 'Status',
            field: 'calculated_status',
            filter_text: "Please type 'Waiting Verification', 'Cancelled', 'Verified', 'Rejected (exact wording)",
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.calculated_status === "waiting verification") {
                    text = <span className="badge bg-teal me-2" style={{ width: "140px" }}>Waiting Verification</span>;
                } else if (data.calculated_status == "verified") {
                    text = <span className="badge bg-paid me-2">Verified</span>;
                } else if (data.calculated_status == "rejected") {
                    text = <span className="badge badge-danger">Rejected</span>;
                } else if (data.calculated_status == "cancelled") {
                    text = <span className="badge bg-red me-2">Cancelled</span>;
                }
                return text;
            },
        },
        { id: 8, title: 'Verified By', field: 'verified_by', sortable: true },
        {
            id: 7,
            title: 'Action',
            render: item => {
                return (
                    <div style={{ width: 100, display: "flex", flexDirection: "column" }}>
                        <div>
                            <a
                                onClick={onEdit(item)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'green',
                                    display: 'inline-block',
                                    marginRight: 20
                                }}
                            >
                                <i className="fas fa-edit" />
                                <span style={{ marginLeft: 10 }}>Edit</span>
                            </a>
                        </div>
                    </div>
                );
            },
        },
    ];


    const genTableColumns = (role_name) => {
        if (role_name == "SO Payment Verificator") {
            return verificator_columns;
        }
        return columns;
    }

    const tableGetData = (role_name) => {
        if (role_name == "SO Payment Verificator") {
            //let filter = {filter:`status:waiting verification`};
            //return (params) => getPO({...filter, ...params});
            return getPO;
        }
        else return getPO;
    }

    const columns = [
        { id: 1, title: 'PO Number', field: 'docnumpo', sortable: true },
        { id: 2, title: 'Order Number', field: 'docnumso', sortable: true },
        { id: 3, title: 'Supplier', field: 'cardname', sortable: true },
        {
            id: 4,
            title: 'Order Type',
            field: 'm_tp_penj',
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.m_tp_penj == 'TRD') {
                    text = "TRADE-IN";
                } else if (data.m_tp_penj == 'FGS') {
                    text = "FINISH GOOD";
                } else if (data.m_tp_penj == 'PMR') {
                    text = "PAMERAN";
                }
                return text;
            },
        },
        {
            id: 5, title: 'Created Date', field: 'created_date', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD HH.MM.SS', example: 2023-03-01 06.30.23. You can also exclude the hour, minute, seconds, date, month or year. Example : 2023-03 and 2023-04-01 16.04",
            render: data => {
                // moment.locale('id');
                return moment(data.created_date).locale('id').format('ll LTS')
            }
        },
        {
            id: 6,
            title: 'Status',
            field: 'status',
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.status == 'Reject') {
                    text = <span className="badge bg-red me-2">REJECT</span>;
                } else if (data.status == 'COMPLETED') {
                    text = <span className="badge bg-paid me-2">COMPLETED</span>;
                } else if (data.status == 'DEDUCTION') {
                    text = <span className="badge bg-teal me-2">DEDUCTION</span>;
                } else if (data.status == 'Waiting Verification') {
                    text = <span className="badge bg-teal" style={{ width: "150px" }}>Waiting Verification</span>;
                } else if (data.status == 'SUBMITTED') {
                    text = (
                        <div>
                            <span className="badge bg-close me-2">SUBMITTED</span>
                            <a
                                onClick={() => onProcessCompleted(data.docnumpo)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'green',
                                    display: 'inline-block',
                                    marginRight: 20
                                }}
                            >
                                <i className="fas fa-sync-alt" />
                                <span style={{ marginLeft: 10 }}>Process Now</span>
                            </a>
                        </div>
                    )
                } else if (data.status == 'Open') {
                    text = <span className="badge bg-cyan me-2">OPEN</span>;
                } else if (data.status == 'DRAFT' || data.status == 'S') {
                    if ((data.verification_status === null && userInfo.role_name !== "SO Payment Verificator")) {
                        text = <span className="badge bg-draft me-2">DRAFT</span>
                    } else if (data.verification_status === null && userInfo.role_name == "SO Payment Verificator") {
                        text = <span className="badge bg-teal me-2">Not verified</span>
                    } else if (data.verification_status === false) {
                        text = <span className="badge badge-danger me-2">Verification Rejected</span>
                    } /*else if(data.verification_status === true) {
                        text=<span className="badge badge-success me-2">Verification Submitted</span>
                    }*/
                    //text = <span className="badge bg-draft me-2">DRAFT</span>;
                } else if (data.status == 'PENDING DM') {
                    text = (
                        <div style={{ width: 150, display: "flex", flexDirection: "column" }}>
                            <span className="badge bg-khaki me-2">PENDING DM</span>
                            <a
                                onClick={() => onProcessPendingDM(data.id)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'green',
                                    display: 'inline-block',
                                    marginRight: 20
                                }}
                            >
                                <i className="fas fa-sync-alt" />
                                <span style={{ marginLeft: 10 }}>Process Now</span>
                            </a>
                        </div>
                    )
                } else if (data.status == 'WAITING APPROVAL') {
                    text = <span className="badge bg-chartreuse me-2">WAITING APPROVAL</span>;
                } else if (data.status == 'CANCELED') {
                    text = <span className="badge bg-red me-2">CANCELED</span>;
                }

                return text;
            },
        },
        {
            id: 7,
            title: 'Action',
            render: item => {
                return (
                    <div style={{ width: 120, display: "flex", flexDirection: "column" }}>
                        <a
                            onClick={onEdit(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-edit" />
                            <span style={{ marginLeft: 10 }}>Edit</span>
                        </a>
                        {item.status == "COMPLETED" && (
                            <a
                                onClick={() => onJourney(item.docnumpo)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'black',
                                    display: 'flex',
                                    alignItems: "center",
                                    marginRight: 20
                                }}
                            >
                                <i className="fas fa-history" />
                                <span style={{ marginLeft: 10 }}>Journey</span>
                            </a>
                        )}

                        {item.status == "COMPLETED" && item.docnum == null && (
                            <a
                                onClick={() => onProcessPOMHC(item.docnumpo)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'darkblue',
                                    display: 'flex',
                                    alignItems: "center",
                                    marginRight: 20
                                }}
                                aria-label='SAP PO MHC'
                            >
                                <i className="fas fa-sign-out-alt" />
                                <span style={{ marginLeft: 10 }}>PO MHC</span>
                            </a>
                        )}
                        {((item.verification_status === false && item.status == "DRAFT") || (item.verification_status === true && item.status == "PENDING DM")) && <div>
                            <a
                                onClick={() => cancelPO(item)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'red',
                                    display: 'flex',
                                    alignItems: "center",
                                    marginRight: 20
                                }}
                            >
                                <i className="fas fa-times" />
                                <span style={{ marginLeft: 10 }}>Cancel</span>
                            </a>
                        </div>}
                    </div>
                );
            },
        },
    ];

    const onPostData = (e, trans, value, payload) => {


        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modena',
                cancelButton: 'btn btn-readonly mr-3'
            },
            buttonsStyling: false
        })
        swalWithBootstrapButtons.fire(
            {
                title: 'Confirmation',
                text: 'Are you sure post to SAP this number ?',
                confirmButtonColor: '#3085d6',
                showCancelButton: true,
                confirmButtonText: 'Sure',
                reverseButtons: true
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {
                setIsLoading(true);
                submitSL(trans, value, payload).then(res => {
                    if (res.status == 200) {
                        Swal.fire({
                            icon: 'success',
                            title: `POST ${trans} success!`,
                        }).then(() => {
                            if (value.charAt(value.length - 2) == '-') {
                                value = value.slice(0, -2);
                            }
                            onJourney(value);
                            // onCancel();
                            // tablePO.current.refresh();
                        });
                    } else {
                        setIsLoading(false);
                        Swal.fire({
                            icon: 'error',
                            title: `POST ${trans} error!`,
                            text: res.data.message
                        });
                    }
                }).catch(err => {
                    setIsLoading(false);
                    Swal.fire({
                        icon: 'error',
                        title: `POST ${trans} error!`,
                        text: err.response.data.message
                    });
                })
            }
        })
    }

    const showAddButton = (role_name) => {
        if (role_name == "SO Payment Verificator" || includes(role_name, "MHC Dealer")) return false;
        return true;
    }

    const propsTable = { columns: genTableColumns(userInfo.role_name), getData: tableGetData(userInfo.role_name), showIndex: true, showAddButton: showAddButton(userInfo.role_name), onAddData, order: 'created_date', direction: 'desc' };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Purchase Order List</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <Overlay display={state.processing} />
                            <div className='table-responsive'>
                                <MTable {...propsTable} ref={tablePO} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ModalForm
                visible={modalVisible}
                onCancel={onCancel}
                params={journeyData}
                onPost={onPostData}
                isLoading={isLoading}

            />
        </div>
    );

};

export default PurchaseOrder;